import BaseComponent from '../abstracts/BaseComponent';

export default class DisableCopyAndPasteComponent extends BaseComponent {
  constructor(element) {
    super(element);
    this.disablePasteFromPasswordConfirmField();
  }

  disablePasteFromPasswordConfirmField() {
    const inputPasswordConfirmField = document.getElementById('registration-form-password-confirm');
    inputPasswordConfirmField.onpaste = function (e) {
      e.preventDefault();
    };
  }
}
